
const translateErrorMessage = (errorMessage) => {
  if (errorMessage.startsWith('User already exists')) {
    return 'ユーザーは既に登録されています。事務局にお問い合わせください。';
  } else if (errorMessage.startsWith('Invalid verification code provided, please try again')) {
    return '確認コードが違います。ご確認後再入力してください。';
  } else if (errorMessage.startsWith('Password did not conform with policy: Password not long enough')) {
    return 'パスワードは半角英数字８文字以上で入力してください。';
  } else if (errorMessage.startsWith('Same member ID  already Exists')) {
    return 'この会員番号は既に存在します。';
  } else if (errorMessage.startsWith('Invalid code provided')) {
    return '確認コードが間違っています。もう一度入力するか、コードのを再申請してください。';
  } else 
    return errorMessage;
  return '';
};

export function onError(error) {
  console.log('onError:');
    console.log(error);
  let message = error.toString();
  console.log(message);
  // Auth errors
  if (!(error instanceof Error) && error.message) {
    console.log('has error.message');
    console.log(error.message);
    message = translateErrorMessage(error.message);
  } else if (error.response) {
    console.log('has error.response');
      console.log(error.response);
      if (error.response.data && error.response.data.error) {
    console.log('has error.response.data.error');
    console.log(error.response.data.error);
	  message = translateErrorMessage(error.response.data.error);
      }
  }
  alert(message);
}
